import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/shared/ui';
import { NotFoundProps } from './NotFound.types';

export const NotFound = ({ title: titleProp, content: contentProp }: NotFoundProps) => {
  const { t } = useTranslation('common');

  // Resolved in the body, not as parameter defaults: the parameter list evaluates
  // before the hook runs.
  const title = titleProp ?? t('notFound.oops');
  const content = contentProp ?? t('notFound.sorryAnUnexpectedErrorHas');

  return (
    <main className="flex h-screen w-full items-center justify-center">
      <EmptyState role="alert" title={title} description={content} />
    </main>
  );
};
